import log from 'loglevel'

// 1. 从 process.env 中获取 Vue CLI 的环境变量
// 默认改为 debug：正式打包亦输出 debug（可用 VUE_APP_LOG_LEVEL 覆盖，如 silent / error / warn / info）
const logLevel = process.env.VUE_APP_LOG_LEVEL || 'debug'
log.setLevel(logLevel)

// 2. 插件式增强：添加时间戳和颜色样式
const originalFactory = log.methodFactory
log.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName)

  return (...args) => {
    const timestamp = new Date().toLocaleTimeString()
    const label = methodName.toUpperCase()

    // 不同级别的颜色配置
    const colors = {
      debug: '#7f8c8d',
      info: '#2ecc71', // 绿色
      warn: '#f39c12', // 橙色
      error: '#e74c3c' // 红色
    }

    // 使用 console 的样式化输出 %c
    rawMethod(
      `%c[${timestamp}] [${label}]`,
      `color: ${colors[methodName]}; font-weight: bold;`,
      ...args
    )
  }
}

log.setLevel(log.getLevel())

export default log
